// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".domain-manage-modal-e6264 .ant-input,.domain-manage-modal-e6264 .ant-select{width:280px}.domain-manage-modal-e6264 .domain-manage-domains-81b64{width:400px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal": "domain-manage-modal-e6264",
	"domains": "domain-manage-domains-81b64"
};
export default ___CSS_LOADER_EXPORT___;
